module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_9006.e1ba1919.png";